import React, { useCallback, useEffect, useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";

const PDFViewContainer = ({ url }) => {
  const [numPages, setNumPages] = useState(null);
  const onLoadSuccess = useCallback((pdf) => {
    setNumPages(pdf.numPages);
  }, []);

  return (
    <div className="pdf-container">
      <Document
        file={url}
        onLoadSuccess={onLoadSuccess}
        // options={{
        //   cMapUrl:
        //     "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/{pdfjs.version}/cmaps/",
        //   cMapPacked: true,
        // }}
      >
        {[...Array(numPages)].map((_, index) => (
          <Page
            key={index}
            pageNumber={index + 1}
            renderAnnotationLayer={false} // Optional: Disable annotations if not needed
            renderTextLayer={false} // Enable text layer for text selection
          />
        ))}
      </Document>
    </div>
  );
};

export default PDFViewContainer;
